import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import * as actions from '../../../../../redux/actions/index';
import { routes, address_attributes } from '../../../../../utility/constants/constants';
import { extractExtention, getUser, resetOrientation, getConvertTo24Hours, convertTo24HourFormat, convertDateFormatV4 } from '../../../../../utility/utility';
import NewShiftForm from '../../../../component/TimeTrackerModuleComponent/ShiftComponent/ShiftCrudComponent/NewShiftComponent/NewShiftForm';
import { animateScroll as scroll } from 'react-scroll'
import { decode, encode } from 'base64-arraybuffer';
import errorHandler from '../../../../../utility/errorHandler/errorHandler';
import moment from 'moment';
import { tzUTCDateConverterTool_V2, tzUTCDateTimeConverterTool_V1, tzUTCDateTimeConverterTool_V1_Prod, tzUTCTCustomDateAndTimeConverterTool, tzUTCTimeConverterTool_V1, tzUTCTimeConverterTool_V1_Prod } from '../../../../../utility/TimezoneOperations/timezoneUtility';
import { TimeTrackerModTypes } from '../../../../../redux/actions/TimeTrackerModAction/TimeTrackerModTypes';
import ErrorAlert from '../../../../../utility/errorHandler/errorAlert';

const cloneDeep = require('clone-deep');


class NewShiftContainer extends Component {
    
    constructor(props) {
        super(props);

    }
    
    componentWillUnmount() {
            this.props.resetState([])
            }
            componentDidMount() {
        console.log("PROPSSS", this.props);

        if (this.props && this.props.match && this.props.match.params && this.props.match.params.shiftId) {
            this.props.getShiftDetailForSingleFLUser(this.props.match.params.shiftId);
        }

        this.props.getUsersListByTheirRoles({ roles: 'frontline' });
        
    }

    getSelectedFLUserJobs = (flUserId) => {

        this.props.getJobAccountSitesList({ userId: flUserId, address: true });

    }

     convertTo24HourFormats = (time12h) => {debugger
        const [time, modifier] = time12h.split(' ');
        let [hours, minutes] = time.split(':');
        
        if (hours === '12') {
          hours = modifier === 'AM' ? '00' : '12';
        } else if (modifier === 'PM') {
          hours = parseInt(hours, 10) + 12;
        }
        
        return `${hours}:${minutes}`;
      };
      
      
        timeToMinutes = (timeStr) => {debugger
        const [hours, minutes] = this.convertTo24HourFormats(timeStr).split(':').map(Number);
        return hours * 60 + minutes;
      };
      
      
      

      doShiftsOverlap = (shift1, shift2) => {
        // Convert times to minutes
        let start1 = this.timeToMinutes(shift1.start_time);
        let end1 = this.timeToMinutes(shift1.end_time);
        let start2 = this.timeToMinutes(shift2.start_time);
        let end2 = this.timeToMinutes(shift2.end_time);

        
        // Handle overnight shifts - if end time is before start time or is explicitly marked overnight
        if (shift1.is_overnight || end1 < start1) {
          end1 += 24 * 60; // Add a day in minutes
        }
        
        if (shift2.is_overnight || end2 < start2) {
          end2 += 24 * 60; // Add a day in minutes
        }
        
        if (start1 === end2 || start2 === end1) {
          return false;
        }
        
        return (start1 < end2 && start2 < end1);
      };
      
      
       findOverlappingShifts = (shifts) => {
        for (let i = 0; i < shifts.length; i++) {
          for (let j = i + 1; j < shifts.length; j++) {
            if (this.doShiftsOverlap(shifts[i], shifts[j])) {
              return {
                hasOverlap: true,
                conflictingShifts: [shifts[i], shifts[j]]
              };
            }
          }
        }
        
        return { hasOverlap: false };
      };
      
      
       findIdenticalTimes = (shifts) => {
        for (let i = 0; i < shifts.length; i++) {
          if (shifts[i].start_time === shifts[i].end_time) {
            return {
              hasIdentical: true,
              shift: shifts[i]
            };
          }
        }
        return { hasIdentical: false };
      };
      
      
       validateShiftForm = (formValues) => {
        const errors = [];
        
        if (!formValues) {
          errors.push("Form values are missing");
          return errors;
        }
    
        
        if (!formValues.items || formValues.items.length === 0) {
          errors.push("At least one shift time slot is required");
          return errors;
        }
        
        const shiftsByDay = {};
        formValues.items.forEach(item => {
          const day = item.days.value.toLowerCase();
          if (!shiftsByDay[day]) {
            shiftsByDay[day] = [];
          }
          shiftsByDay[day].push(item);
        });
        
        Object.entries(shiftsByDay).forEach(([day, shifts]) => {
          const identicalCheck = this.findIdenticalTimes(shifts);
          if (identicalCheck.hasIdentical) {
            errors.push(`Start Time and End Time can't be identical on ${day}`);
          }
          
          const overlapCheck = this.findOverlappingShifts(shifts);
          if (overlapCheck.hasOverlap) {
            const shift1 = overlapCheck.conflictingShifts[0];
            const shift2 = overlapCheck.conflictingShifts[1];
            errors.push(`Overlapping shifts on ${day}: (${shift1.start_time} - ${shift1.end_time}) and (${shift2.start_time} - ${shift2.end_time})`);
          }
        });
        
        return errors;
      };

    handleSubmit = (values) => {

        if (values) {
            console.log(values);
            
            if (values.shiftOrigin) {

                if (values.shiftOrigin.accountIds && values.shiftOrigin.accountIds.length == 0) {
                    errorHandler('Job is Required');
                    return false;
                }

                /* START TIME && END TIME FUNCTIONALITY VALIDATION */
                if (values.shiftOrigin.start_time && values.shiftOrigin.end_time) {
                    let shiftStart = new Date(`${moment(values.shiftOrigin.start_date).format('YYYY-MM-DD')} ${getConvertTo24Hours(values.shiftOrigin.start_time)}`);
                    let shiftEnd = new Date(`${moment(values.shiftOrigin.end_date).format('YYYY-MM-DD')} ${getConvertTo24Hours(values.shiftOrigin.end_time)}`);

                    if (values.shiftOrigin.start_time == values.shiftOrigin.end_time) {
                        errorHandler("Start Time and End Time can't be identical");
                        return false;
                    }
                    if (values.shiftOrigin.start_time.includes('PM') && values.shiftOrigin.end_time.includes('AM')) {
                        errorHandler('Select a time range that falls within a single day');
                        return false;
                    }
                }

            }

        }

        let setData = { data: {} };
        let fetchedValues = cloneDeep(values.shiftOrigin);

        let findRemovedAccountIds = (array1, array2) => {
            return array1.reduce((acc, item1) => {
                const isMatched = array2.some(item2 => item1.id == item2.value);
                if (!isMatched) {
                    acc.push(Number(item1.id));
                }
                return acc;
            }, []);
        };

        /* For capturing arrived duplicate jobs */
        let identifyArrivedDuplicateJobs = (jobsArray) => {
            let accrossedJobId = new Set();
            let repeatedJobIdArray = new Set();
            const originJobIdArray = [];

            jobsArray.forEach(num => {
                if (accrossedJobId.has(num)) {
                    repeatedJobIdArray.add(num);
                } else {
                    accrossedJobId.add(num);
                    originJobIdArray.push(num);
                }
            });

            return {
                duplicateJobId: [...repeatedJobIdArray],
                originJobIdArray
            };
        }

        if (this.props && this.props.match && this.props.match.params && this.props.match.params.shiftId) {
            /* For Edit Flow */

            if (fetchedValues["accountIds"]) {
                setData['data']['accountIds'] = fetchedValues['accountIds'].map(e => Number(e.value));

                // For capturing arrived duplicate jobs
                let capturedJobsErrorHandler = identifyArrivedDuplicateJobs(setData['data']['accountIds']);
                if (capturedJobsErrorHandler && capturedJobsErrorHandler.duplicateJobId && capturedJobsErrorHandler.duplicateJobId.length > 0) {
                    errorHandler('Please remove the same selected Jobs');
                    return false;
                }

                let removedAccountIds = findRemovedAccountIds(this.props.getShiftDetailOfSingleFLUser.accounts, fetchedValues.accountIds);
                if (!(removedAccountIds.length == 0)) {
                    setData["data"]["removeAccountIds"] = removedAccountIds
                }
            }
            setData['data']['user_id'] = Number(fetchedValues['user_id']['value']);
            setData['data']['start_date'] = tzUTCDateTimeConverterTool_V1(fetchedValues['start_date'], convertTo24HourFormat(fetchedValues['start_time']), 'from');
            setData['data']['end_date'] = tzUTCDateTimeConverterTool_V1(fetchedValues['end_date'], convertTo24HourFormat(fetchedValues['end_time']), 'from');
            setData['data']['start_time'] = tzUTCTimeConverterTool_V1(convertDateFormatV4(fetchedValues['start_date']), convertTo24HourFormat(fetchedValues['start_time']));
            setData['data']['end_time'] = tzUTCTimeConverterTool_V1(convertDateFormatV4(fetchedValues['start_date']), convertTo24HourFormat(fetchedValues['end_time']));
            setData['data']['notes'] = fetchedValues['notes'];

            this.props.editFrontlinerShift(setData, this.props.match.params.shiftId);

        } else {

            const validationErrors = this.validateShiftForm(fetchedValues);

            if(validationErrors?.length > 0){
                ErrorAlert(validationErrors[0]);
                return false;
            }else{
                const timezone = values.shiftOrigin.accountIds[0]?.timezone
            
                if (!fetchedValues || !fetchedValues['user_id'] || !fetchedValues['start_date']) {
               errorHandler('Required data is missing');
               return false;
                }
   
           if (fetchedValues["accountIds"]) {
               setData['data']['accountIds'] = fetchedValues['accountIds'].map(e => Number(e.value));
           }
   
   
           let groupedShifts = {};
           let endTime;
           if (fetchedValues['items'] && Array.isArray(fetchedValues['items'])) {
               fetchedValues['items'].forEach(item => {
                   let day = item.days.value.toLowerCase(); 
                   if (!groupedShifts[day]) {
                       groupedShifts[day] = [];
                   }
   
                   if (convertTo24HourFormat(item.end_time) < convertTo24HourFormat(item.start_time)) {
                       endTime = moment(fetchedValues['start_date']).add(1, 'days')._d;
                   } else {
                       endTime = fetchedValues['start_date'];
                   }
   
                   let startTime = tzUTCTCustomDateAndTimeConverterTool(convertDateFormatV4(fetchedValues['start_date']), convertTo24HourFormat(item.start_time));
                   let endTimeConverted = tzUTCTCustomDateAndTimeConverterTool(convertDateFormatV4(endTime), convertTo24HourFormat(item.end_time));
   
                   groupedShifts[day].push({
                       start: startTime,
                       end: endTimeConverted,
                       is_overnight: item.is_overnight
                   });
               });
           }
           
           let shifts = Object.keys(groupedShifts).map(day => ({
               day: day,
               slots: groupedShifts[day]
           }));
   
           setData['data']['shifts'] = shifts;
   
           if (!moment(fetchedValues['start_date']).isValid()) {
               errorHandler('Invalid start date');
               return false;
           }
           setData['data']['user_id'] = Number(fetchedValues['user_id']['value']);
           setData['data']['start_date'] = tzUTCDateConverterTool_V2(convertDateFormatV4(fetchedValues['start_date']),"from");
           setData['data']['end_date'] = tzUTCDateConverterTool_V2(convertDateFormatV4(fetchedValues['end_date']),"to");
           setData['data']['notes'] = fetchedValues['notes'];
           setData['data']['timezone'] = timezone;
               this.props.checkFrontlinerShift(setData, 'create');
            }
            setData['data']['platform'] = "web";

        }

    }

    onCancelClicked = () => {
        this.props.handleCancelClickAction();
        this.props.history.push(routes.SHIFT_SCHEDULE);
    }

    hanldeReVampingShift = (values) => {
        /* For ReInitializing Shift Flow */

        let setData = { data: {} };
        let fetchedValues = cloneDeep(values.shiftOrigin);

        setData['data']['accountIds'] = fetchedValues['accountIds'].map(e => Number(e.value));
        setData['data']['user_id'] = Number(fetchedValues['user_id']['value']);
        setData['data']['start_date'] = tzUTCDateTimeConverterTool_V1(fetchedValues['start_date'], convertTo24HourFormat(fetchedValues['start_time']), 'none');
        setData['data']['end_date'] = tzUTCDateTimeConverterTool_V1(fetchedValues['end_date'], convertTo24HourFormat(fetchedValues['end_time']), 'none');
        setData['data']['start_time'] = tzUTCTimeConverterTool_V1(convertDateFormatV4(fetchedValues['start_date']), convertTo24HourFormat(fetchedValues['start_time']));
        setData['data']['end_time'] = tzUTCTimeConverterTool_V1(convertDateFormatV4(fetchedValues['start_date']), convertTo24HourFormat(fetchedValues['end_time']));
        setData['data']['notes'] = fetchedValues['notes'];

        this.props.createFrontlinerShift(setData);
    }

    render() {
        return (
            <div>

                <NewShiftForm
                    {...this.props}
                    getSelectedFLUserJobs={this.getSelectedFLUserJobs}
                    onSubmit={this.handleSubmit}
                    onCancelClicked={this.onCancelClicked}
                    hanldeReVampingShift={this.hanldeReVampingShift}
                />

            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.authReducer.user,
        isLoading: state.TimeTrackerModReducer.isLoading,
        isEditFLShiftForm: state.TimeTrackerModReducer.isEditFLShiftForm,
        isUpdateFLShiftForm: state.TimeTrackerModReducer.isUpdateFLShiftForm,
        isTimeTrackerModalOpen: state.TimeTrackerModReducer.isTimeTrackerModalOpen,

        jobAccountSitesList: state.TimeTrackerModReducer.jobAccountSitesList,
        frontlineUsersList: state.TimeTrackerModReducer.usersListBySelectedRole,
        getShiftDetailOfSingleFLUser: state.TimeTrackerModReducer.getShiftDetailOfSingleFLUser,
        FLShiftDetailBasedAvalibality: state.TimeTrackerModReducer.FLShiftDetailBasedAvalibality,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        resetTimeTrackerObjects: () => dispatch(actions.resetTimeTrackerObjects()),
        handleCancelClickAction: () => dispatch(actions.handleCancelClickAction()),
        handleFrequentTimeTracker_openModal: (data) => dispatch(actions.handleFrequentTimeTracker_openModal(data)),
        handleFrequentTimeTracker_closeModal: (data) => dispatch(actions.handleFrequentTimeTracker_closeModal(data)),

        getJobAccountSitesList: (params) => dispatch(actions.getJobAccountSitesList(params)),
        getUsersListByTheirRoles: (params) => dispatch(actions.getUsersListByTheirRoles(params)),
        getShiftDetailForSingleFLUser: (id) => dispatch(actions.getShiftDetailForSingleFLUser(id)),

        checkFrontlinerShift: (data, formType) => dispatch(actions.createFrontlinerShift(data, formType)),
        createFrontlinerShift: (data) => dispatch(actions.createFrontlinerShift(data)),
        editFrontlinerShift: (data, id) => dispatch(actions.editFrontlinerShift(data, id)),
        resetState: (payload) => dispatch({
            type: TimeTrackerModTypes.GET_SHIFT_DETAIL_AVALABLITY_FLUSER_FULFILLED,
            payload
    }),

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewShiftContainer);
